<template>
  <div class="more-position-page">
    <LoginButton  @menu-select="handleMenuSelect" />

    <div class="main-content">
      <!-- 左侧筛选栏 -->
      <div class="filter-sidebar">
        <div class="filter-header">
          <div class="filter-title-container">
            <img src="../assets/img/noun-job.png" alt="" class="filter-title-icon">
            <h3 class="filter-title">更多岗位</h3>
          </div>
          <div class="filter-action-container">
            <span class="filter-action-name">筛选条件</span>
            <span class="filter-action-clear" @click="clearAllFilters">清空</span>
          </div>
        </div>
        <!-- 筛选条件 -->
        <div class="filter-section">
          <div class="filter-group">
            <div class="filter-city">
              <img src="../assets/img/local.png" alt="" class="filter-city-icon">
              <div class="name">深圳</div>
            </div>
          </div>
          <!-- 发布时间 -->
          <div class="filter-group">
            <h3 class="filter-title">发布时间</h3>
            <div class="filter-options" style="gap: 12px 0;">
              <el-checkbox v-for="item in publishTimeOptions" :key="item.value"
                :value="query.publishTime === item.value"
                @change="(checked) => handlePublishTimeChange(item.value, checked)" class="filter-option">
                {{ item.label }}
              </el-checkbox>
            </div>
          </div>

          <!-- 工作性质 -->
          <div class="filter-group">
            <h3 class="filter-title">工作性质</h3>
            <div class="filter-options">
              <el-checkbox-group v-model="query.workNature" @change="handleFilterChange">
                <el-checkbox v-for="item in workNatureOptions" :key="item.value" :label="item.value"
                  class="filter-option">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <!-- 学历要求 -->
          <div class="filter-group">
            <h3 class="filter-title">学历要求</h3>
            <div class="filter-options">
              <el-checkbox-group v-model="query.education" @change="handleFilterChange">
                <el-checkbox v-for="item in educationOptions" :key="item.value" :label="item.value"
                  class="filter-option">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <!-- 岗位类别 -->
          <div class="filter-group">
            <h3 class="filter-title">岗位类别</h3>
            <div class="filter-options">
              <el-checkbox-group v-model="query.category" @change="handleFilterChange">
                <el-checkbox v-for="item in categoryOptions" :key="item.value" :label="item.value"
                  class="filter-option">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧主内容区 -->
      <div class="content-area">
        <!-- 岗位列表 -->
        <div style="display: flex;flex-direction: column;height: 100%;">
          <div class="job-search">
            <el-input v-model="query.keywords" @change="handleSearch">
              <template #suffix>
                <div class="search-icon" @click="handleSearch">
                  <img src="../assets/img/search.png" alt="">
                </div>
              </template>
            </el-input>
          </div>
          <div class="job-list" v-infinite-scroll="loadMore" :infinite-scroll-disabled="loading"
            :infinite-scroll-distance="10">
            <div v-for="job in moreList" :key="job.id" class="job-item" :class="{ active: selectedJob?.id === job.id }"
              @click="selectJob(job)">
              <div class="job-checkbox">
                <el-checkbox v-model="selectedJobs" :label="job.id" @click.stop>
                  <span style="display: none;">{{ job.id }}</span>
                </el-checkbox>
              </div>

              <div class="job-info-container">
                <h4 class="job-title">{{ job.title }}</h4>
                <div class="job-info">
                  <div class="job-info-l">
                    <div class="job-logo">
                      <!-- <img :src="job.companyLogo || '/api/placeholder/40/40'" :alt="job.company_name || job.short_name"> -->
                    </div>
                    <div>
                      <div class="company-name">{{ job.company_name || job.short_name || '未知公司' }}</div>
                      <div class="company-desc">{{ job.category }}</div>
                    </div>
                  </div>
                  <div class="job-info-r">
                    <div class="education">{{ getEducationText(job.education) }}</div>
                    <div style="display: flex;align-items: center;">
                      <div class="location">{{ job.city }}</div>
                      <div class="work-nature">{{ job.work_nature }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 加载状态 -->
            <div v-if="loading" class="loading-container">
              <i class="el-icon-loading"></i>
              <span>加载中...</span>
            </div>

            <!-- 没有更多数据提示 -->
            <div v-if="!hasMore && moreList.length > 0" class="no-more-container">
              <span>没有更多数据了</span>
            </div>
          </div>
          <!-- 全选 -->
          <div class="select-all-container">
            <el-checkbox :model-value="isAllSelected" :indeterminate="isIndeterminate" @change="handleSelectAll"
              class="select-all-checkbox">
              全选
            </el-checkbox>
          </div>
        </div>

        <!-- 岗位详情 -->
        <div style="display: flex;flex-direction: column;height: 100%; flex: 1;">
          <div class="job-detail" v-if="selectedJob">
            <div class="detail-header">
              <h2 class="detail-title">{{ selectedJob.title }}</h2>
            </div>

            <div class="detail-content">
              <!-- 岗位职责 -->
              <div class="detail-section" v-if="selectedJob.description">
                <h3 class="section-title">岗位职责：</h3>
                <p class="section-content">{{ selectedJob.description }}</p>
              </div>

              <!-- 任职要求 -->
              <div class="detail-section" v-if="selectedJob.requirement">
                <h3 class="section-title">任职要求：</h3>
                <p class="section-content">{{ selectedJob.requirement }}</p>
              </div>

              <!-- 匹配度 -->
              <!-- <div class="detail-section" v-if="selectedJob.match_score !== undefined">
                 <h3 class="section-title">匹配度</h3>
                 <div class="match-score">
                   <el-progress 
                     :percentage="selectedJob.match_score * 100" 
                     :format="format => `${format}%`"
                     :stroke-width="20"
                     color="#67C23A"
                   />
                 </div>
               </div> -->
            </div>

          </div>
          <!-- 操作按钮 -->
          <div class="detail-actions">
            <el-button type="primary" @click="applyJob" class="apply-btn">立即投递</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMoreList } from '@/api/recommend'

// 防抖函数
const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func.apply(this, args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export default {
  name: 'MorePosition',
  data() {
    return {
      query: {
        page_no: 1,
        page_size: 20,
        publishTime: null,
        education: [],
        city: [],
        keywords: '',
        workNature: [],
        category: []
      },
      moreList: [],
      selectedJob: null,
      selectedJobs: [],
      loading: false,
      hasMore: true,
      totalCount: 0,
      // 筛选选项
      publishTimeOptions: [
        { label: '一天内', value: 0 },
        { label: '三天内', value: 1 },
        { label: '一周内', value: 2 },
        { label: '一月内', value: 3 }
      ],
      educationOptions: [
        { label: '未知', value: 0 },
        { label: '初中', value: 1 },
        { label: '高中', value: 2 },
        { label: '大专', value: 3 },
        { label: '本科', value: 4 },
        { label: '硕士', value: 5 },
        { label: '博士', value: 6 }
      ],
      workNatureOptions: [
        { label: '全职', value: '全职' },
        { label: '兼职', value: '兼职' },
        { label: '实习', value: '实习' },
      ],
      categoryOptions: [
        { label: '互联网岗位', value: '互联网岗位' },
        { label: '电子/电气/通信', value: '电子/电气/通信' },
        { label: '人力/行政/法务', value: '人力/行政/法务' },
        { label: '会计', value: '会计' },
        { label: '生产制造', value: '生产制造' },
        { label: '教育培训', value: '教育培训' },
        { label: '设计', value: '设计' },
        { label: '房地产/建筑', value: '房地产/建筑' },
        { label: '直播/影视/传媒', value: '直播/影视/传媒' },
        { label: '市场/公关/广告', value: '市场/公关/广告' },
        { label: '供应链', value: '供应链' },
        { label: '汽车', value: '汽车' },
        { label: '医疗健康', value: '医疗健康' },
        { label: '金融', value: '金融' },
        { label: '项目管理', value: '项目管理' },
        { label: '咨询/翻译/法律', value: '咨询/翻译/法律' },
        { label: '能源/环保/农业', value: '能源/环保/农业' },
        { label: '高级管理', value: '高级管理' },
      ]
    }
  },
  computed: {
    isAllSelected() {
      return this.moreList.length > 0 && this.selectedJobs.length === this.moreList.length
    },

    // 添加半选状态的计算属性
    isIndeterminate() {
      return this.selectedJobs.length > 0 && this.selectedJobs.length < this.moreList.length
    }
  },
  mounted() {
    this.getMoreList()
  },
  methods: {

    handleMenuSelect(item) {
      console.log('点击了菜单项:', item)
    },
    async getMoreList(isLoadMore = false) {
      if (this.loading) return

      this.loading = true

      try {
        const res = await getMoreList(this.query)
        console.log(res);

        if (res.data && res.data.code === 1) {
          console.log(res.data);

          const newList = res.data.data.lists || []
          this.totalCount = res.data.data.count || 0

          if (isLoadMore) {
            // 加载更多：追加数据
            this.moreList = [...this.moreList, ...newList]
          } else {
            // 首次加载或搜索：替换数据
            this.moreList = newList
            if (this.moreList.length > 0) {
              this.selectedJob = this.moreList[0]
            }
          }

          // 判断是否还有更多数据
          this.hasMore = this.moreList.length < this.totalCount

        } else {
          this.$message.error(res.data?.msg || '获取岗位列表失败')
        }
      } catch (error) {
        console.error('获取岗位列表失败:', error)
        this.$message.error('获取岗位列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },



    clearSearch() {
      this.query.keywords = ''
      this.handleFilterChange()
    },

    // 处理搜索
    handleSearch() {
      this.query.page_no = 1
      this.hasMore = true
      this.getMoreList()
    },

    // 加载更多数据
    loadMore() {
      if (!this.hasMore || this.loading) return

      this.query.page_no += 1
      this.getMoreList(true)
    },

    // 清空所有筛选条件
    clearAllFilters() {
      // 重置所有筛选条件到初始状态
      this.query = {
        page_no: 1,
        page_size: 20,
        publishTime: null,
        education: [],
        city: [],
        keywords: '',
        workNature: [],
        category: []
      }

      // 清空选中的岗位
      this.selectedJobs = []

      // 重置分页状态
      this.hasMore = true

      // 重新获取岗位列表
      this.getMoreList()

      // 提示用户
      this.$message.success('已清空所有筛选条件')
    },

    handleFilterChange() {
      this.query.page_no = 1
      this.hasMore = true
      this.getMoreList()
    },

    handlePublishTimeChange(value, checked) {
      if (checked) {
        this.query.publishTime = value
      } else {
        this.query.publishTime = null
      }
      this.handleFilterChange()
    },

    handleSelectAll(checked) {
      if (checked) {
        // 全选：将所有岗位的id添加到selectedJobs数组中
        this.selectedJobs = this.moreList.map(job => job.id)
      } else {
        // 取消全选：清空selectedJobs数组
        this.selectedJobs = []
      }
    },

    selectAllCities() {
      const allCities = this.cityOptions.map(item => item.value)
      this.query.city = [...allCities]
      this.handleFilterChange()
    },

    selectJob(job) {
      this.selectedJob = job
    },

    getEducationText(education) {
      const educationMap = {
        0: '未知',
        1: '初中',
        2: '高中',
        3: '大专',
        4: '本科',
        5: '硕士',
        6: '博士'
      }
      return educationMap[education] || '未知'
    },



    applyJob() {
      if (!this.selectedJob) {
        this.$message.warning('请先选择岗位')
        return
      }
      this.$message.success(`已投递岗位：${this.selectedJob.title}`)
    }
  }
}
</script>

<style scoped lang="scss">
// 变量定义
$primary-color: #B16EF9;
$text-primary: #111827;
$text-secondary: #374151;
$text-muted: #6b7280;
$text-light: #9ca3af;
$border-light: #f3f4f6;
$bg-light: #f5f5f5;
$bg-white: white;
$danger-color: #dc2626;
$shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);

// 混合器
@mixin flex-center {
  display: flex;
  align-items: center;
}

@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@mixin transition($property: all) {
  transition: $property 0.2s ease;
}

@mixin icon-base($size: 16px) {
  width: $size;
  height: $size;
  position: relative;
}

@mixin absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

::v-deep .el-checkbox__inner {
  border-color: #c6c6c6;
}

::v-deep .el-checkbox__inner:hover {
  border-color: $primary-color;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: $primary-color;
}

::v-deep .el-checkbox__inner::after {
  border: 1px solid $primary-color;
  border-left: 0;
  border-top: 0;
}

::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  background-color: $primary-color;
}

// 统一 el-checkbox 样式
::v-deep .el-checkbox__label {
  font-size: 14px;
  color: $text-muted;
  @include transition(color);
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: $primary-color;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fff;
  border-color: $primary-color;
}

// 主容器
.more-position-page {
  background-color: rgba(255, 255, 255, 1);
  background: url(../assets/img/dash_1x.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}



// 主内容区
.main-content {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding-top: 132px;
  padding-left: 44px;
  padding-right: 44px;
  padding-bottom: 56px;
}

// 左侧筛选栏
.filter-sidebar {
  margin-right: 24px;
  width: 300px;
  height: 100%;
  border: 1px solid $primary-color;
  background: linear-gradient(339deg, rgba(255, 255, 255, 0) 1%, rgba(255, 255, 255, 0.2) 98%);
  overflow-y: auto;
  box-shadow: $shadow;
  padding: 16px 2px;
  border-radius: 12px;

  // 隐藏滚动条但保持滚动功能
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */

  &::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari and Opera */
  }

  .filter-header {
    padding: 0 10px;
    margin-bottom: 12px;

    .filter-title-container {
      display: flex;
      align-items: center;

      .filter-title-icon {
        width: 50px;
        height: 42px;
        margin-right: 8px;
      }

      .filter-title {
        font-size: 20px;
        font-weight: 600;
        line-height: normal;
        background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }

    .filter-action-container {
      padding: 0 8px;
      margin-top: 20px;
      display: flex;
      align-items: center;

      .filter-action-name {
        flex: 1;
        font-size: 16px;
        font-weight: 600;
        background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .filter-action-clear {
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        color: #656587;
        padding: 4px 8px;
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
          background-color: rgba(177, 110, 249, 0.1);
          color: $primary-color;
        }

        &:active {
          transform: scale(0.95);
        }
      }
    }
  }

  .filter-section {
    display: flex;
    flex-direction: column;

    .filter-group {
      .filter-city {
        margin-bottom: 20px;
        margin-left: 16px;
        padding: 0 8px;
        width: 80px;
        height: 24px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);

        .filter-city-icon {
          width: 16px;
          height: 16px;
        }

        .name {
          flex: 1;
          text-align: center;
          font-size: 12px;
          font-weight: 600;
          color: #656587;
        }
      }

      .filter-title {
        font-size: 14px;
        color: #656587;
        background: linear-gradient(180deg, rgba(177, 110, 249, 0.1) 0%, rgba(126, 180, 235, 0.1) 100%);
        padding: 2px 10px;
        border-radius: 16px;
      }

      .filter-options {
        padding: 10px 16px;
        display: flex;
        flex-wrap: wrap;

        ::v-deep {

          .el-radio-group,
          .el-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            gap: 8px 0;
            width: 100%;
          }

          .el-radio,
          .el-checkbox {
            width: 50%;
            margin-right: 0;
          }

          .el-radio__label {
            font-size: 12px;
            color: $text-muted;
            @include transition(color);
          }

          .el-radio__input.is-checked+.el-radio__label {
            color: $primary-color;
          }

          .el-radio__input.is-checked .el-radio__inner {
            background-color: #fff;
            border-color: $primary-color;
          }
        }


        .filter-option {
          &.select-all {
            margin-top: 6px;
            padding-top: 6px;
            border-top: 1px solid $border-light;
            font-weight: 500;
          }
        }
      }
    }
  }
}

// 右侧内容区
.content-area {
  flex: 1;
  display: flex;
  overflow: hidden;

}

.job-search {
  display: flex;
  margin-bottom: 18px;

  ::v-deep .el-input__inner {
    padding-right: 80px;
    height: 40px;
    background: linear-gradient(275deg, rgba(255, 255, 255, 0) 2%, #FFFFFF 99%);
    border-radius: 16px 24px 24px 16px;
    border-color: $primary-color;
  }

  .search-icon {
    cursor: pointer;
    width: 70px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid $primary-color;
    transition: all 0.2s ease;

    // &:active {
    //   transform: scale(0.95);
    // }

    img {
      width: 16px;
      height: 16px;
    }
  }
}

// 岗位列表
.job-list {
  flex: 1;
  width: 600px;
  max-height: 560px;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
    background: #a9aabd;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, #7EB4EB 0%, #B16EF9 100%);
    border-radius: 6px;
  }

    .job-item {
      margin-top: 10px;
      display: flex;
      align-items: flex-start;
      padding: 10px 0;
      border-bottom: 1px dashed $primary-color;
      cursor: pointer;
      @include transition(background-color);

      &:first-child {
        margin-top: 0;
      }

      .job-checkbox {
        display: flex;
        margin-right: 10px;
      }

      .job-logo {
        width: 42px;
        height: 42px;
        background: $border-light;
        margin-right: 8px;
      }

      .job-info-container {
        flex: 1;

        .job-title {
          font-size: 16px;
          font-weight: 600;
          line-height: 18px;
          color: #656587;
          margin-bottom: 12px;
        }

        .job-info {
          display: flex;
          align-items: center;

          .job-info-l {
            flex: 1;
            display: flex;
            align-items: center;

            .company-name {
              font-size: 16px;
              font-weight: 500;
              line-height: 18px;
              color: #656587;
              margin-bottom: 8px;
            }

            .company-desc {
              font-size: 16px;
              font-weight: 500;
              line-height: 18px;
              color: #989898;
            }
          }

          .job-info-r {
            padding-right: 12px;
            font-size: 16px;
            font-weight: 500;
            line-height: 18px;
            color: #656587;

            .education {
              margin-bottom: 10px;
            }

            .location {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }

  // 加载状态样式
  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: $text-muted;
    font-size: 12px;

    .el-icon-loading {
      margin-right: 8px;
      font-size: 16px;
      animation: rotating 2s linear infinite;
    }
  }

  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .no-more-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    color: $text-light;
    font-size: 12px;
  }

  .select-all-container {
    padding: 14px 0;
    margin-bottom: 14px;

    ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #fff;
      border-color: $primary-color;
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #fff;
      border-color: $primary-color;
    }

    ::v-deep .el-checkbox__label {
      font-size: 14px;
      font-weight: 600;
      color: $primary-color;
    }

    .select-all-checkbox {
      font-size: 12px;
      font-weight: 500;
      background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;



    }
  }

  // 岗位详情
  .job-detail {
    margin-left: 24px;
    padding: 28px 16px;
    border: 1px solid $primary-color;
    background: linear-gradient(339deg, rgba(255, 255, 255, 0) 1%, rgba(255, 255, 255, 0.2) 98%);
    overflow-y: auto;
    box-shadow: $shadow;
    border-radius: 12px;
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */

    &::-webkit-scrollbar {
      display: none;
      /* Chrome, Safari and Opera */
    }

    .detail-header {
      margin-bottom: 24px;
      padding-bottom: 16px;

      .detail-title {
        font-size: 20px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #656587;
      }
    }

    .detail-content {
      margin-bottom: 32px;

      .detail-section {
        // margin-bottom: 30px;

        .section-title {
          font-weight: normal;
          font-size: 14px;
          color: #656587;
        }

        .section-content {
          font-size: 14px;
          color: #656587;

          ol {
            padding-left: 16px;
          }

          li {
            margin-bottom: 8px;
          }
        }

        .match-score {
          margin-top: 12px;

          ::v-deep .el-progress {
            .el-progress-bar__outer {
              background-color: #f5f7fa;
            }

            .el-progress-bar__inner {
              background: linear-gradient(90deg, #67c23a 0%, #85ce61 100%);
            }

            .el-progress__text {
              font-weight: 600;
              color: #67c23a;
            }
          }
        }
      }
    }
  }

  .detail-actions {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;

    .apply-btn {
      width: 140px;
      height: 40px;
      border-radius: 24px;
      background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) -3%, rgba(126, 180, 235, 0.6) 100%);
      backdrop-filter: blur(24px);
      // box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
      font-size: 20px;
      font-weight: 600;
      border: none;
    }
  }

  // 响应式设计
  @media (max-width: 1200px) {
    .filter-sidebar {
      width: 280px;
    }

    .job-list {
      width: 300px;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

    .filter-sidebar {
      width: 100%;
      height: auto;
      max-height: 280px;
    }

    .content-area {
      flex-direction: column;
    }

    .job-list {
      width: 100%;
      height: 280px;
    }

    .job-detail {
      height: auto;
    }
  }</style>